<template>
  <div v-if="card">
    <h1>{{ card.title }}</h1>
    <div class="text-center p-4 rounded-lg" :class="[card.type]">
      <img
        v-if="card.type === 'attack'"
        src="@/assets/images/attack.svg"
        :style="{ width: '2em' }"
        class="align-middle"
      />
      <img
        v-else-if="card.type === 'defence' || card.type === 'defense'"
        src="@/assets/images/defence.svg"
        :style="{ width: '1.65em' }"
        class="align-middle"
      />
      <img
        v-else-if="card.type === 'versatile'"
        src="@/assets/images/versatile.svg"
        :style="{ width: '2em' }"
        class="align-middle"
      />
      <img
        v-else-if="card.type === 'scheme'"
        src="@/assets/images/scheme.svg"
        :style="{ height: '2em' }"
        class="align-middle"
      />
      <span class="h1 align-middle" v-if="card.type !== 'scheme'">
        {{ card.value }}
      </span>
    </div>

    <div class="mt-4">
      <h3>Effects</h3>
      <p v-if="card.basicText">
        {{ card.basicText }}
      </p>
      <p v-if="card.type !== 'scheme' && card.immediateText">
        <strong>Immediately:</strong> {{ card.immediateText }}
      </p>
      <p v-if="card.type !== 'scheme' && card.duringText">
        <strong>During combat:</strong> {{ card.duringText }}
      </p>
      <p v-if="card.type !== 'scheme' && card.afterText">
        <strong>After combat:</strong> {{ card.afterText }}
      </p>
    </div>

    <div v-if="card.notes">
      <h3>Notes</h3>
      <p v-html="parseMarkdown(card.notes)"></p>
    </div>

    <div>
      <h3>Decks</h3>
      <b-table
        :items="card.decks"
        :fields="fields"
        responsive
        class="compact-table-sm"
      >
        <template v-slot:cell(name)="data">
          <router-link
            :to="{ name: 'UmDbDeck', params: { slug: data.item.slug } }"
          >
            {{ data.value }}
          </router-link>
        </template>

        <template v-slot:cell(quantity)="data">
          &times;{{ data.value }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import markdown from "@/mixins/markdown";

export default {
  name: "UmDbCard",
  mixins: [markdown],
  metaInfo() {
    const title = this.card ? `${this.card.title} | Cards | UmDb` : undefined;
    return {
      title,
    };
  },
  data() {
    return {
      card: null,
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "characterName",
          label: "Character",
          sortable: true,
        },
        {
          key: "boost",
          tdClass: ["text-right"],
          thClass: "vertical",
          sortable: true,
        },
        {
          key: "quantity",
          tdClass: ["text-right"],
          thClass: "vertical",
          sortable: true,
        },
      ],
    };
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  methods: {
    getCard() {
      api
        .getDBCard(this.slug)
        .then((data) => {
          this.card = data;
        })
        .catch(() => {
          this.$router.replace({ name: "Error" });
        });
    },
  },
  mounted() {
    this.getCard();
  },
};
</script>

<style lang="less" scoped>
@defence-blue: #2c76ac;
@attack-red: #dc3034;
@versatile-violet: #6c4e8d;
@scheme-yellow: #fcbd71;
.attack {
  background-color: @attack-red !important;
  color: white;
}

.defense,
.defence {
  background-color: @defence-blue !important;
  color: white;
}

.versatile {
  background-color: @versatile-violet !important;
  color: white;
}

.scheme {
  background-color: @scheme-yellow !important;
  color: white;
}
</style>
